import { CustomerBrandingDTO } from "../DTO/customerBrandingDTO";
import { BasicRequest } from "./basicRequest";

export class CreateBrandingRequest extends BasicRequest{

    public customerBranding!: CustomerBrandingDTO;

    constructor(){
        super();
    }
}